import React from 'react';
import s from './VideoListContent.module.scss';
import defaultImg from '@/assets/images/usual/default_img.png';
import ToastUtils from '@/utils/ToastUtils';

/**
 * 视频列表内容组件
 * 用于展示视频列表
 */
const VideoListContent = ({ videos = [], onVideoClick, onDetailClick, onContinueAsk }) => {
    // 直接使用传入的视频数据
    const displayVideos = videos;

    // 检查视频是否存在
    const checkVideoExists = (video) => {
        if (!video || !video.id) {
            ToastUtils.showToast('该视频不存在');
            return false;
        }
        return true;
    };

    // 处理查看视频按钮点击
    const handleWatchClick = (video, index, videos) => {
        if (checkVideoExists(video)) {
            onVideoClick?.(video, index, {
                list: videos,
                themeColor: document.body?.getAttribute?.('data-theme')
            });
        }
    };

    // 处理详情按钮点击
    const handleDetailClick = (video, index) => {
        if (checkVideoExists(video)) {
            onDetailClick?.(video, index);
        }
    };

    return (
        <div className={s['video-list-container']}>
            {/* 视频列表 */}
            <div className={s['video-list']}>
                {displayVideos.map((video, index) => (
                    <div key={video.id || index} className={s['video-item']}>
                        {/* 视频缩略图 */}
                        <div 
                            className={`${s['video-thumbnail']} ${s[video.thumbnailColor || 'blue']}`}
                            data-color={video.thumbnailColor}
                        >
                            <img 
                                src={video.thumbnail || defaultImg} 
                                alt={video.title}
                                onError={(e) => {
                                    // 如果加载失败，使用默认图片
                                    if (e.target.src !== defaultImg) {
                                        e.target.src = defaultImg;
                                    }
                                }}
                            />
                        </div>

                        {/* 视频信息 */}
                        <div className={s['video-info']}>
                            <h4 className={s['video-title']} title={video.title}>
                                {video.title}
                            </h4>
                            {/* 操作按钮 */}
                            <div className={s['video-actions']}>
                                <button 
                                    className={s['watch-btn']}
                                    onClick={() => handleWatchClick(video, index, videos)}
                                >
                                    查看视频
                                </button>
                                <button 
                                    className={s['detail-btn']}
                                    onClick={() => handleDetailClick(video, index)}
                                >
                                    详情
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* 继续提问按钮 */}
            <div className={s['footer-actions']}>
                <button 
                    className={s['continue-btn']}
                    onClick={onContinueAsk}
                >
                    继续提问
                </button>
            </div>
        </div>
    );
};

export default VideoListContent;

